import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useRequestStore = defineStore('request', () => {
    const all = ref(null);

    const actions = {
        search: (params) => axios.get('/api/v1/requests', { params }),
        storeRequest: (params) => axios.post('/api/v1/requests', params),
        completeRequest: (params) => axios.post('/api/v1/requests/' + params.hash + '/complete', params),
        cancelRequest: (params) => axios.post('/api/v1/requests/' + params.hash + '/cancel'),
    };

    return {
        all,
        ...actions,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useRequestStore.acceptHMRUpdate);
}
